import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../../utils/api.types";
import { ICustomerSliceState, IOpeningBalanceHistory } from "../../utils/customer.types";
import {
    fetchCustomers,
    fetchCustomersWithFilters,
    fetchCustomersById,
    updateServicesCustomerById,
    adjustPartyOpeningBalance,
    fetchPartyOpeningBalanceHistory
} from "../customerStore/customerThunk";

/**
 * Customer slice initial state.
 */
const initialState: ICustomerSliceState = {
    customers: [],
    rowCount: 0,
    status: ApiStatus.IDLE,
    errorMessage: '',
    customerDetails: {},
    openingBalanceHistory: [],
    openingBalanceHistoryStatus: ApiStatus.IDLE
}

/**
 * Customer Slice.
 */
const customerSlice = createSlice({
    name: 'customer',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch customers
            .addCase(fetchCustomers.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchCustomers.fulfilled, (state, action:any) => {
                state.status = ApiStatus.SUCCESS;
                console.log(action?.payload );
                state.customers = action?.payload.customers || [];
                state.rowCount = action?.payload.total || 0;
                state.errorMessage = '';
            })
            .addCase(fetchCustomers.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Fetch customers with filters
            .addCase(fetchCustomersWithFilters.pending, (state, action) => {
                state.customers = [];
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchCustomersWithFilters.fulfilled, (state, action:any) => {
                state.status = ApiStatus.SUCCESS;
                state.customers = action?.payload.customers || [];
                state.rowCount = action?.payload.total || 0;
                state.errorMessage = '';
            })
            .addCase(fetchCustomersWithFilters.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.customers = [];
                state.errorMessage = action.error.message
            })

            // Fetch Customer by userId
            .addCase(fetchCustomersById.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchCustomersById.fulfilled, (state, action:any) => {
                state.status = ApiStatus.SUCCESS;
                state.customerDetails= action?.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchCustomersById.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })
            // Fetch updateServicesCustomerById by userId
            .addCase(updateServicesCustomerById.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(updateServicesCustomerById.fulfilled, (state, action:any) => {
                state.status = ApiStatus.SUCCESS;
                const { message} = action?.payload
                state.errorMessage = '';
                toast.success(message);
            })
            .addCase(updateServicesCustomerById.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Adjust Party Opening Balance
            .addCase(adjustPartyOpeningBalance.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(adjustPartyOpeningBalance.fulfilled, (state, action:any) => {
                state.status = ApiStatus.SUCCESS;
                const { message } = action?.payload;
                state.errorMessage = '';
                toast.success(message || 'Opening balance adjusted successfully');
            })
            .addCase(adjustPartyOpeningBalance.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message;
                toast.error(action.error.message || 'Failed to adjust opening balance');
            })

            // Fetch Party Opening Balance History
            .addCase(fetchPartyOpeningBalanceHistory.pending, (state, action) => {
                state.openingBalanceHistoryStatus = ApiStatus.LOADING;
            })
            .addCase(fetchPartyOpeningBalanceHistory.fulfilled, (state, action:any) => {
                state.openingBalanceHistoryStatus = ApiStatus.SUCCESS;
                state.openingBalanceHistory = action?.payload?.data?.history || [];
                state.errorMessage = '';
            })
            .addCase(fetchPartyOpeningBalanceHistory.rejected, (state, action) => {
                state.openingBalanceHistoryStatus = ApiStatus.FAILED;
                state.openingBalanceHistory = [];
                state.errorMessage = action.error.message;
            })
    }
});

export default customerSlice.reducer;
